export const meta = {
  id: 'bst',
  name: 'Binary Search Tree Operations',
  category: 'Tree',
  complexity: {
    time: 'O(log n)',
    space: 'O(n)'
  },
  description: 'Binary Search Tree operations including insert, search, and delete. Maintains sorted property for efficient lookup.'
};
